import { lighten } from "@mui/system";

enum Color {
    Orange = '#ED7D31',
    Green = '#70AD47',
    Blue = '#5B9BD5',
    LightBlue = '#7BADE5',
    Transparent = 'transparent',
    Border = 'red'
}

export const diagram = {
    node: {
        figure: {
            rect: 'RoundedRectangle',
            circle: 'Circle'
        },
        width: {
            rect: 150,
            circle: 50,
        },
        color: {
            pipe: Color.Green,
            psv: Color.Orange,
            etc: Color.Blue,
            connector: Color.Blue,
            border: {
                pipe: lighten(Color.Green, .5),
                psv: lighten(Color.Orange, .5),
                etc: lighten(Color.Blue, .5),
                connector: lighten(Color.Blue, .5)
            }
        }
    },
    link: {
        color: {
            show: Color.LightBlue,
            hide: Color.Transparent
        }
    }
}
